import * as React from "react";

import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { FormControlLabel, FormGroup, IconButton, Switch } from "@mui/material";
import Menu from "@mui/material/Menu";
import { useTranslation } from "react-i18next";
import { useDataState } from "./KendoDataGrid";

export default function ColumnsMenu(props) {
  const { storageKey } = props;
  const { t } = useTranslation();
  const { columnState, initialColumns } = useDataState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    const storedColumns = ColumnMenuHelper.getColumn(storageKey);
    if (Array.isArray(storedColumns)) {
      if (storedColumns.length === initialColumns.length)
        columnState[1](
          storedColumns.map((c, i) => {
            Object.keys(initialColumns[i]).forEach((key) => {
              if (typeof initialColumns[i][key] === "function") {
                c[key] = initialColumns[i][key];
              }
            });
            c.title = initialColumns[i].title;
            c.type = initialColumns[i].type;
            c.filter = initialColumns[i].filter;
            c.tKey = initialColumns[i].tKey;
            c.dataItemKey = initialColumns[i].dataItemKey;
            c.textField = initialColumns[i].textField;
            return c;
          })
        );
      else ColumnMenuHelper.removeColumn(storageKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    ColumnMenuHelper.setColumn(columnState[0], storageKey);
  }, [columnState[0]]);

  const changeColumnVisiblity = (field, hidden) => {
    const newColumns = columnState[0].map((column) => {
      if (column.field === field) {
        return { ...column, hidden };
      }
      return column;
    });
    columnState[1](newColumns);
  };
  return (
    <div style={{ display: "inline-block" }}>
      <IconButton
        color="primary"
        onClick={handleClick}
        aria-controls={open ? "column-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <ViewColumnIcon />
      </IconButton>

      <Menu
        id="column-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "column-button",
        }}
      >
        <FormGroup sx={{ p: 2 }}>
          {columnState[0]
            .filter((d) => d.title && d.title !== " ")
            .map((column) => (
              <FormControlLabel
                name={column.field}
                key={column.field}
                onChange={(event) => {
                  changeColumnVisiblity(
                    event.target.name,
                    !event.target.checked
                  );
                }}
                control={<Switch checked={!column.hidden} />}
                label={t(column.title)}
              />
            ))}
        </FormGroup>
      </Menu>
    </div>
  );
}

const ColumnMenuHelper = {
  removeColumn: (key) => localStorage.removeItem(key),
  getColumn: (key) => JSON.parse(localStorage.getItem(key) || "{}"),
  setColumn: (columns, key) => {
    localStorage.setItem(key, JSON.stringify(columns));
  },
};
